'use client';

import { useState } from 'react';
import Link from 'next/link';
import AppImage from './AppImage';
import Icon from './AppIcon';

interface NavLink {
  id: string;
  label: string;
  href: string;
}

export default function TopNavigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks: NavLink[] = [
    { id: 'nav_home', label: 'Home', href: '/homepage' },
    { id: 'nav_products', label: 'Products', href: '/products' },
    { id: 'nav_about', label: 'About Us', href: '/about' },
    { id: 'nav_contact', label: 'Contact & Partnerships', href: '/contact' },
    { id: 'nav_faq', label: 'FAQ', href: '/faq' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-border shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 md:h-24">
          {/* Logo & Brand */}
          <Link href="/homepage" className="flex items-center justify-center group">
            <div className="w-[220px] h-[90px] relative flex items-center justify-center">
              <AppImage
                src="/assets/images/BAF_Website_Logo-1771319612387.png"
                alt="Bloom Animal Feeds logo"
                className="object-contain"
                width={220}
                height={90}
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className="px-4 py-2 text-base font-medium text-foreground hover:text-primary hover:bg-secondary/50 rounded-lg transition-all"
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="/contact"
              className="ml-2 px-6 py-2.5 text-base font-bold bg-primary text-primary-foreground rounded-full hover:bg-primary/90 transition-all shadow-md hover:shadow-lg"
            >
              Become a Distributor
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg hover:bg-secondary transition-colors"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <Icon name="XMarkIcon" size={24} className="text-foreground" />
            ) : (
              <Icon name="Bars3Icon" size={24} className="text-foreground" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-border bg-white">
          <div className="px-4 py-2 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 text-base font-medium text-foreground hover:text-primary hover:bg-secondary/50 rounded-lg transition-all"
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-base font-bold text-center bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all mt-2"
            >
              Become a Distributor
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}